import React from 'react';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import commonS from '../../s.module.less';
import s from './s.module.less';
import PaymentContent, { PaymentContentRef } from 'components/PaymentContent';
import { savePaymentInfo } from 'api/ppaOnboarding';
import { IPaymentInfo } from 'types/common';

interface Props {
    initValue?: IPaymentInfo | null;
    onSave?: () => void;
}

const PaymentInformation: React.FC<Props> = (props) => {
    const { initValue, onSave } = props;


    const handlePaymentMethodCreated = async (paymentMethodId: string) => {
        try {
            await savePaymentInfo({
                paymentMethodId,
            });
            onSave?.();
        } catch (error) {
            console.error('Save payment information failed:', error);
        }
    };

    const renderEditing = () => {
        return (
            <PaymentContent hidePolicy onPaymentMethodCreated={handlePaymentMethodCreated} />
        );
    };

    const renderReview = () => {
        if (!initValue) {
            return (
                <div>
                    Not provided
                </div>
            );
        }

        const { type, last4, expMonth, expYear, country, postalCode, bankName, accountName, } = initValue;

        // 隐藏卡号，只显示后4位
        const maskedCardNumber = last4 ? `**** **** **** ${last4.slice(-4)}` : '-';

        const renderCard = () => {
            return (
                <div>
                    <div className={commonS.row}>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Card number</div>
                            <div className={commonS.value}>{maskedCardNumber}</div>
                        </div>
                    </div>

                    <div className={commonS.row}>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Expiration date</div>
                            <div className={commonS.value}>{expMonth}/{expYear}</div>
                        </div>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>CVC</div>
                            <div className={commonS.value}>***</div>
                        </div>
                    </div>

                    <div className={commonS.row}>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Country</div>
                            <div className={commonS.value}>{country || '-'}</div>
                        </div>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Postal code</div>
                            <div className={commonS.value}>{postalCode || '-'}</div>
                        </div>
                    </div>
                </div>
            );
        };

        const renderBank = () => {
            return (
                <div>
                    <div className={commonS.row}>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Bank name</div>
                            <div className={commonS.value}>{bankName || '-'}</div>
                        </div>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Account name</div>
                            <div className={commonS.value}>{accountName || '-'}</div>
                        </div>
                    </div>
                    <div className={commonS.row}>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Country</div>
                            <div className={commonS.value}>{country || '-'}</div>
                        </div>
                        <div className={commonS.displayItem}>
                            <div className={commonS.label}>Postal code</div>
                            <div className={commonS.value}>{postalCode || '-'}</div>
                        </div>
                    </div>
                </div>
            );
        };

        return (
            type === 'card' ? renderCard() : renderBank()
        );
    };

    return (
        <FormCard type='review' title='Payment information' hasContent={true}>
            {(isEditing) => isEditing ? renderEditing() : renderReview()}
        </FormCard>
    );
};

export default PaymentInformation;